export enum PwaStatus {
    Initial = 0, 
    Installed = 1, 
    Dismissed = 2, 
    Postponed = 3,
}
